<template>
  <div class="xy-module-content">
    <div class="xy-module-title van-hairline--bottom">
      <form action="javascript:void 0">
        <input v-model="name"
               type="search"
               class="xy-search-box van-hairline--surround"
               @keyup.13="searchBtn"
               placeholder="用户名或姓名" />
      </form>
      <div @click="viewBtn">筛选</div>
      <popupSearch :isView="isView" @listenToChildClose="closeSearch" @listenToChildCSubmit="submitSearch"></popupSearch>
    </div>
    <div class="xy-module-body" style="margin-top: 10px;">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-collapse v-model="activeUserID" accordion>
            <van-collapse-item title="标题1" :name="item.UserID" v-for="(item,index) in list" :key="index" >
              <template #title>
                <div class="title-group">
                  <Avatar style="width:60px;height:60px;line-height:60px;margin-right:10px;" :iconPath="item.Icon?$store.state.apiPath + item.Icon:item.Icon" :fullName="item.FullName" class="avatar"></Avatar> 
                  <div>
                    <p class="name">{{item.FullName.substr(0,15)}}</p>
                    <p class="full">{{item.UserName}}</p>
                    <p class="score">均分:{{item.AvgScore}}</p>
                  </div>
                </div>
              </template>
              <table>
                <thead>
                  <tr>
                    <th width="50%">一级指标</th>
                    <th width="25%">得分</th>
                    <th width="25%">权重</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item1,index1) in tableData" :key="index1">
                    <td>{{item1.IndexManagementName}}</td>
                    <td>{{item1.AvgScore.toFixed(2)}}</td>
                    <td>{{item1.ScoreRate.toFixed(2)+"%"}}</td>
                  </tr>
                </tbody>
              </table>
            </van-collapse-item>
          </van-collapse>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import Avatar from '@/pages/attendance/components/Avatar.vue'
import popupSearch from "@/pages/evaluation/views/classroomRecord/popupSearch";
export default {
   components: {
    popupSearch,
    Avatar
  },
  data() {
    return {
      activeUserID: "",
      name:'',
      isView:false,
      loading: false,
      finished: false,
      isLoading: false,
      list:[],
      tableData:[],
      objS:{},
      objT:{},
      num: 1,
      pageSize: 15,
      AcademicSessionID:0,
      AcademicYearID:0,

    }
  },
  watch: {
    activeUserID: {
      handler (val) {
        this.activeUserID = val
        if(this.activeUserID){
          this.changeCollapse()
        }
      },
      deep: true
    }
  },
  created(){
    this.objS = this.$store.state.evaluation.schooolObj
    this.objT = this.$store.state.evaluation.timeObj
  },
  methods:{
    // 查询单个表格
    async changeCollapse(){
      this.xy.loading()
      await this.xyapi.post(`${this.$store.state.apiPath}/api/IndexContrast/GetMobileStudentIndexScoreDetail`,{
        StudentID:this.activeUserID,
        AcademicSessionID:this.AcademicSessionID,
        AcademicYearID:this.AcademicYearID,
        StartDate:this.startDateText?this.startDateText:this.objT.startDateText,
        EndDate:this.endDateText?this.endDateText:this.objT.endDateText,
        SchoolDistrictID:this.SchoolDistrictID?this.SchoolDistrictID:this.objS.schoolDistrictID,
        StudentGradeForStudentYearID:this.StudentGradeForStudentYearID?this.StudentGradeForStudentYearID:this.objS.studentGradeForStudentYearID,
        DisciplineID:this.DisciplineID
      }).then(res => {
        this.xy.unloading()
        if (res.success) {
          this.tableData = res.data
        }
      })
    },
    // 请求接口
    async onLoad() {
      let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/IndexContrast/GetMobileStudentIndexScoreList`, {
        PageIndex: this.num,
        pageSize: this.pageSize,
        AcademicSessionID:this.AcademicSessionID,
        AcademicYearID:this.AcademicYearID,
        StartDate:this.startDateText?this.startDateText:this.objT.startDateText,
        EndDate:this.endDateText?this.endDateText:this.objT.endDateText,
        SchoolDistrictID:this.SchoolDistrictID?this.SchoolDistrictID:this.objS.schoolDistrictID,
        StudentGradeForStudentYearID:this.StudentGradeForStudentYearID?this.StudentGradeForStudentYearID:this.objS.studentGradeForStudentYearID,
        DisciplineID:this.DisciplineID,
        Name:this.name
      });
      let _list = res.data.data;
      this.list = [...this.list, ..._list];
      
      this.loading = false;
      this.num++;
      this.finished = this.list.length >= res.data.totalRecords ? true : false;
      if(this.list.length !==0){
        this.activeUserID=this.list[0].UserID
      }
    },
    // 刷新 加载第一页
    onRefresh() {
       setTimeout(() => {
        this.list = [];
        this.num = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
    // 搜索
    searchBtn () {
      this.onRefresh()
    },
    viewBtn () {
      this.isView = true;
    },
    closeSearch (val) {
      this.isView = val
    },
    submitSearch (value) {
      this.isView = false
      this.startDateText=value.startDateText
      this.endDateText=value.endDateText
      this.StudentGradeForStudentYearID=value.studentGradeForStudentYearID
      this.AcademicSessionID=value.academicSessionID
      this.AcademicYearID=value.AcademicYearID
      this.SchoolDistrictID=value.schoolDistrictID
      this.DisciplineID=value.subjTextectId==='0'?[]:[value.subjTextectId]
      this.onRefresh()
    },
  }
}
</script>  
<style lang="less" scoped>
/deep/ .van-collapse-item__content{
  padding-top:0;
}
.xy-module-content {
  position: relative;
  .xy-module-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 0 40px;
    background: #fff;
    font-size: 28px;
  }
}
.xy-search-box {
  border: none;
  padding: 0 20px;
  width: 582px;
  height: 62px;
  background: rgba(242, 242, 242, 1);
  border-radius: 31px;
}
.title-group{
  display: flex;
  align-items: center;
  .name{
    color:rgba(0,0,0,0.85);
    font-size: 16px;
    line-height: 35px;
    height: 35px;
    font-weight: 700;
  }
  .full{
    font-size: 12px;
    color:rgba(0,0,0,0.25);
    line-height: 35px;
    height: 35px;
  }
  .score{
    font-size: 13px;
    color:rgba(0,0,0,0.65);
    line-height: 35px;
    height: 35px;
  }
}
 table {
    width: 100%;
    thead{
      background: rgba(232,234,237,1);
      th{
        height: 60px;
        line-height: 60px;
        td{
          color:rgba(22,22,22,1);
          font-size: 14px;
        }
      }
      th:first-child{
        text-align: left;
        padding-left:10px;
      }
    }
    tbody {
      background: #fdfcfc;
      tr {
        text-align: center;
        td{
          font-size: 13px;
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #ebe9e9;
          text-align: center;
          padding:11px 15px;
        }
        td:first-child{
          text-align: left;
        }
      }
      tr:last-child{
        td{
          border:none;
        }
      }
    }
 }
</style>